module.exports = __webpack_public_path__ + "img/logo-round.075df2d5.png";